import { render, staticRenderFns } from "./TreeMapWidget.vue?vue&type=template&id=35dd2465&scoped=true&"
import script from "./TreeMapWidget.vue?vue&type=script&lang=js&"
export * from "./TreeMapWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd2465",
  null
  
)

export default component.exports